import React from 'react';
import { analyze } from '../utils/smsSegments';

// "142 characters, 1 segment, GSM-7" under a text box. Turns amber when the
// text has fallen into UCS-2 and names the characters that did it, since one
// pasted curly quote is enough to more than double what a text costs.
//
// Counts the text as typed. Merge fields such as {{customer_name}} are counted
// at their own length, so the real message can be longer.
function SmsSegmentCounter({ text, maxSegments }) {
  const a = analyze(text || '');
  const over = maxSegments && a.segments > maxSegments;
  const ucs2 = a.encoding === 'UCS-2';
  const color = over ? 'var(--error-color, #c62828)' : ucs2 ? '#b26a00' : undefined;
  return (
    <p className="text-muted" style={{ fontSize: '0.8125rem', marginTop: '4px', color }} aria-live="polite">
      {a.characters} character{a.characters === 1 ? '' : 's'}, {a.segments} segment{a.segments === 1 ? '' : 's'}, {a.encoding}
      {maxSegments ? ` (limit ${maxSegments})` : ''}
      {ucs2 && a.nonGsm.length > 0 && (
        <> &middot; switched to UCS-2 by {a.nonGsm.map((c) => `"${c}"`).join(' ')}</>
      )}
    </p>
  );
}

export default SmsSegmentCounter;
